import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FiTagModule } from '@fi-shared/tag';
import { FiInputKeyboardNavigationModule } from '@fi-shared/fi-directives/input-keyboard-navigation';
import { ObjectsSelectorComponent } from './objects-selector.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiHighlightModule } from '@fi-shared/highlight';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        FiTagModule,
        FiInputKeyboardNavigationModule,
        FiAppTextSharedModule,
        FiHighlightModule,
    ],
    declarations: [ObjectsSelectorComponent],
    exports: [ObjectsSelectorComponent],
})
export class FiObjectsSelectorComponentModule {}
